export default __webpack_public_path__ + "static/media/icon_settlement_active_new.18e322d8.svg";